import Input from 'components/Input';
import { useTranslate } from 'hooks/translation-hooks';
import { useSelector } from 'react-redux';
import { zipCodePatternSelector } from 'redux/selectors/config';

const PostalCode = ({ register, errors, title }) => {
  const t = useTranslate('caseOpening');
  const pattern = new RegExp(useSelector(zipCodePatternSelector));
  return (
    <Input
      {...register('postalCode', {
        required: true,
        pattern,
      })}
      error={errors.postalCode && 'incident_location-postal_code_error_format'}
      label={t(title || 'incident_location-postal_code')}
      placeholder={t('incident_location-postal_code_placeholder')}
      maxLength={20}
      testId="postalCode"
    />
  );
};

export default PostalCode;
